import React from 'react';
import { stripDuplicateCleanerLink } from './agentDuplicateMessage';
import { AgentChatMarkdown } from './AgentChatMarkdown';
import AgentSongListCard from './AgentSongListCard';
import { splitSongListSegments } from './agentSongList';

interface AgentChatMessageBodyProps {
  content: string;
  /** While tokens arrive, markdown still renders so tables and emphasis stay readable. */
  streaming?: boolean;
  /** Stats card already has the open button — drop the matching markdown link. */
  hideDuplicateCleanerLink?: boolean;
  /** Conversation id, so card actions can post their outcome into the thread. */
  runId?: string;
  /** True while the run is still working, so card actions wait their turn. */
  busy?: boolean;
}

export const AgentChatMessageBody: React.FC<AgentChatMessageBodyProps> = ({
  content,
  streaming = false,
  hideDuplicateCleanerLink = false,
  runId,
  busy = false,
}) => {
  const body =
    hideDuplicateCleanerLink && !streaming
      ? stripDuplicateCleanerLink(content)
      : content;

  if (!body) return null;
  return (
    <div className={streaming ? 'agent-message-stream' : undefined}>
      {splitSongListSegments(body, streaming).map((segment, index) =>
        segment.type === 'songlist' ? (
          <AgentSongListCard
            key={`songlist-${index}`}
            raw={segment.raw}
            label={segment.label}
            runId={runId}
            busy={busy || streaming}
          />
        ) : (
          <AgentChatMarkdown key={`markdown-${index}`} content={segment.text} />
        ),
      )}
    </div>
  );
};

// Settled messages re-render on every streamed token otherwise, and the
// markdown work across a long thread is what makes streaming feel jumpy.
export default React.memo(AgentChatMessageBody);
